<template lang="html">
  <v-container>
    <v-list shaped dense rounded grow
            color="grey lighten-4"
            class="text-center"
    >
      <v-list-item-group>
        <v-row>
          <v-col>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().startOf('day'), moment().endOf('day'))"
              >
                <v-list-item-title>Today</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day'))"
              >
                <v-list-item-title>Yesterday</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().startOf('week'), moment().endOf('week'))"
              >
                <v-list-item-title>This Week</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().startOf('month'), moment().endOf('month'))"
              >
                <v-list-item-title>This month</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().startOf('year'), moment().endOf('year'))"
              >
                <v-list-item-title>This year</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col>

            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(15, 'minute'), moment())"
              >
                <v-list-item-title>Last 15 minutes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(30, 'minute'), moment())"
              >
                <v-list-item-title>Last 30 minutes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(1, 'hour'), moment())"
              >
                <v-list-item-title>Last hour</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(12, 'hour'), moment())"
              >
                <v-list-item-title>Last 12 hours</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(24, 'hour'), moment())"
              >
                <v-list-item-title>Last 24 hours</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(7, 'day'), moment())"
              >
                <v-list-item-title>Last 7 days</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col>

            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(30, 'day'), moment())"
              >
                <v-list-item-title>Last 30 days</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(60, 'day'), moment())"
              >
                <v-list-item-title>Last 60 days</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(90, 'day'), moment())"
              >
                <v-list-item-title>Last 90 days</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(6, 'month'), moment())"
              >
                <v-list-item-title>Last 6 months</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="blue--text"
                                   @click="goFromTo(moment().subtract(1, 'year'), moment())"
              >
                <v-list-item-title>Last year</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list-item-group>
    </v-list>

  </v-container>
</template>

<script>
  import {SEARCH_NS} from "@/store/modules/search/constants";
  import {mapActions} from 'vuex'
  import moment from "moment";

  export default {
    name: 'DateTimeQuick',
    data: () => ({
    }),
    methods: {
      ...mapActions(SEARCH_NS, [
        'toggleDateTimePanel',
        'updatePeriod'
      ]),
      moment(arg) {
        return moment(arg);
      },
      goFromTo(from, to) {
        this.updatePeriod({
          begin: from,
          end: to
        });
        this.toggleDateTimePanel();
      }
    }
  }
</script>